import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { findIndex } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { FormsService } from 'src/app/services/forms.service';
import {
  EntityType,
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
  StockLocation,
} from '../../../shared/enums';
import { BadeLoftService } from '../bade-loft.service';

interface DataItem {
  _id: string;
  Name: string;
  EtaDate: string;
  Status: string;
  CreatedBy: string;
  CreatedId: string;
  CreatedOn: string;
  ModifyBy: string;
  ModifyId: string;
  ModifyOn: string;
  ContainerNumber: string;
  PartNumbers: PartNumber[];
}

interface PartNumber {
  PartNumber: string;
  OrderedQuantity: number;
  Note: string;
  TotalAssignedQuantity: number;
  AssignmentList: AssignmentList[];
}

interface AssignmentList {
  AssignmentId: string;
  AssignedQuantity: number;
  CustomerId: string;
  CustomerName: string;
  TransactionID: string;
  InvoiceNo: string;
}

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css'],
})
export class StockComponent implements OnInit {
  //#region properties
  stockLocation: typeof StockLocation;
  lst_StockLocation: any = [];
  lst_Stock: any = [];
  isVisible: boolean = false;
  expandSet = new Set<number>();
  isShowArchiveStock: boolean = false;
  editStockDetail: any = null;
  sortField: string = 'createddate';
  sortBy: number = SortBy.Dsc;
  page: number = 1;
  pageSize: number = 100;
  totalRecord: number = 0;
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  currentPageData: any = [];
  isStockLoaded: boolean = false;
  isAuditVisible: boolean = false;
  entityDetails: any;
  entityType: number = EntityType.Stock;
  stockMaxPageSize: number = 0;
  isImportClicked: boolean = false;
  movedPartDetail: any;
  lst_AnotherStocks: any = [];
  selectedStock: string = '';
  selectedCustomer: string = '';
  stockList_Request: any;
  quantityForMove: any;
  isPartNumberLoaded: boolean = false;
  isQuantityExists: boolean = false;
  isVisibleAler: boolean = false;
  inWareHouseStockId: string = '';
  inWareHouseStockIndex: number = 0;
  isEditPartPopOver: boolean = false;
  lst_Stocks: any;
  //#endregion

  //#region functions

  GetAssignmentDetails(id: any, PartNumbers: any, pi: number, i: number) {
    this._blS.GetStockAssignmentDetailV1(id, PartNumbers).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this.lst_Stock[i].partNumbers[pi]['assignmentList'] =
            res.result && res.result.length > 0 ? res.result : [];
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.resultMsg);
        }
      }
    });
  }

  currentPartId: any;
  currentStockData: any;
  currentPartData: any = null;
  hideShowEditPart(event: any, partData: any, data: any) {
    this._fS.addPartNumberForm.reset();
    this.currentStockData = data;
    this.currentPartData = partData;
    this.isEditPartPopOver = event;
    if (this.isEditPartPopOver) {
      this.currentPartId = partData.id;
      this._fS.addPartNumberForm.patchValue({
        partNumber: partData.partNumber,
        orderQuantiry: partData.orderedQuantity,
        notes: partData.note,
      });

      //remove validations of username and password while edit user
      const partNumberControl = this._fS.addPartNumberForm.get('partNumber');
      this._fS.addPartNumberForm
        .get('partNumber')
        ?.valueChanges.subscribe((userCategory) => {
          if (this.isEditPartPopOver) {
            partNumberControl?.setValidators(null);
          }
        });
    }
  }

  updatePartNumber() {
    if (this.isEditPartPopOver) {
      const partNumberControl = this._fS.addPartNumberForm.get('partNumber');
      this._fS.addPartNumberForm
        .get('partNumber')
        ?.valueChanges.subscribe((userCategory) => {
          if (this.isEditPartPopOver) {
            partNumberControl?.setValidators(null);
          }
        });
    }
    this._cS.markFormGroupTouched(this._fS.addPartNumberForm);
    if (this._fS.addPartNumberForm.valid) {
      var formValue = this._fS.addPartNumberForm.value;
      var index = this.lst_Stock.findIndex(
        (obj: any) => obj.id == this.currentStockData.id
      );
      var stockIndex = this.lst_Stock.findIndex(
        (obj: any) => obj.id == this.currentStockData.id
      );
      var partIndex = this.lst_Stock[stockIndex].partNumbers.findIndex(
        (obj: any) => obj.partNumber == formValue.partNumber
      );
      if (
        formValue.orderQuantiry <
        this.lst_Stock[stockIndex].partNumbers[partIndex].totalAssignedQuantity
      ) {
        //formValue.orderQuantiry = null;
        //this.isQuantityExists = true;
        this._cS.displayMessage(
          ResponseMessageStatus.warning,
          'Entered part quantity is lesser than assigned part quantity in the stock'
        );
      } else {
        var partBody = {
          id: this.lst_Stock[stockIndex].id,
          partNumber: this.currentPartData.partNumber,
          orderedQuantity: formValue.orderQuantiry,
          note: formValue.notes,
        };
        this._blS.UpdatePartNumber(partBody).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.Success) {
              this._cS.displayMessage('success', response.message);
              this.lst_Stock[stockIndex].partNumbers[
                partIndex
              ].orderedQuantity = formValue.orderQuantiry;
              this.lst_Stock[stockIndex].partNumbers[partIndex].note =
                formValue.notes ? formValue.notes.trim() : '';
            } else {
              this._cS.displayMessage('error', response.message);
            }
          },
          (error) => {
            this._cS.displayMessage('error', error.message);
          }
        );
        this.hideShowEditPart(false, null, null);
      }
    }
  }

  onQueryParamsChange(event: any) {
    this.pageSize = this.pageSize;
    this.page = event;
    this.getStockList();
  }

  getStockList() {
    this.isStockLoaded = true;
    this._cdref.detectChanges();
    try {
      this.stockList_Request = this._blS
        .GetStocks(
          encodeURIComponent(this.searchText.trim()),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          false,
          this.isShowArchiveStock
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success && res.result) {
              var data = res.result.records;
              this.totalRecord = res.result.totalRecord;
              this.stockMaxPageSize = res.result.totalPage;
              if (data && data.length > 0) {
                data.forEach((x: any) => {
                  this.lst_Stock.push(x);
                });
              }
              this.lst_Stock.map((x: any) => {
                x.expand = false;
                x.isShowlocationChange = false;
                // x.partNumbers.map((x: any) => {
                //   x.visibleAssigned = false;
                // });
              });
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
              isShowArchiveStock: this.isShowArchiveStock,
            };
            this._cS.setLocalStorageItem(
              'stock_data',
              JSON.stringify(local_data)
            );
            this.isStockLoaded = false;
          }
        });
    } catch (error) {}
  }

  changeArchive(event: any) {
    this.isShowArchiveStock = event;
    this.lst_Stock = [];
    this.page = 1;
    if (this.stockList_Request) this.stockList_Request.unsubscribe();
    this.getStockList();
  }

  archiveStock(data: any, i: number) {
    this._blS.UpdateStockAsArchive(data.id).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          //if (this.lst_Stock.length > 1) {
          this.lst_Stock.splice(i, 1);
          this.lst_Stock = [...this.lst_Stock];
          // }
          //  else {
          //   this.page = this.page > 1 ? this.page - 1 : this.page;
          //   this.getStockList();
          // }
          // this.getStockList(false);
        } else {
          this._cS.displayMessage('error', res.message);
        }
      }
    });
  }

  showAddUpdateStock(isImport = false) {
    this.isImportClicked = isImport;
    this.isVisible = true;
  }

  editStock(data: object) {
    this.editStockDetail = data;
    this.showAddUpdateStock();
  }

  confirm(data: any, i: any): void {
    this._blS.DeleteStock(data.id).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this._cS.displayMessage('success', res.message);
          this.lst_Stock.splice(i, 1);
          this.lst_Stock = [...this.lst_Stock];
        } else {
          this._cS.displayMessage('error', res.message);
        }
      }
    });

    //this.nzMessageService.info('click confirm');
  }

  hideModal(event: any) {
    if (event.hide) {
      if (this.editStockDetail)
        this.editStockDetail.partNumbers =
          this.editStockDetail.partNumbers &&
          this.editStockDetail.partNumbers.length > 0
            ? this.editStockDetail.partNumbers
            : [];
      this.isVisible = !event.hide;
      if (event.data && !this.editStockDetail && !this.isShowArchiveStock) {
        // this.page = 1;
        // this.lst_Stock = [];
        // this.getStockList();
        event.data.expand = false;
        event.data.isShowlocationChange = false;
        // event.data.partNumbers.map((x: any) => {
        //   x.visibleAssigned = false;
        // });
        this.lst_Stock.unshift(event.data);
      } else if (event.data) {
        // this.page = 1;
        // this.lst_Stock = [];
        // this.getStockList();
        event.data.expand = false;
        event.data.isShowlocationChange = false;
        // event.data.partNumbers.map((x: any) => {
        //   x.visibleAssigned = false;
        // });
        var editIndex = this.lst_Stock.findIndex(
          (x: any) => x.id == event.data.id
        );
        this.lst_Stock[editIndex] = event.data;
      }
      this.editStockDetail = null;
      this.lst_Stock = [...this.lst_Stock];
    }
  }

  partNumberApiResponse: any;
  onExpandChange(i: number, checked: boolean, data: any): void {
    this.lst_Stock[i].expand = checked;
    this.lst_Stock[i].partNumbers = [];
    setTimeout(() => {
      if (this.lst_Stock[i].expand) {
        if (this.partNumberApiResponse)
          this.partNumberApiResponse.unsubscribe();
        this.isPartNumberLoaded = true;
        // this._blS.GetStockAssignmentDetail(data.id).subscribe((res) => {
        //   if (res) {
        //     if (res.responseStatus == ResponseStatus.Success) {
        //       this.lst_Stock[i].partNumbers = res.result.stockPartNumbers ? res.result.stockPartNumbers : [];
        //     } else {
        //       this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        //     }
        //   }
        //   this.isPartNumberLoaded = false;
        // });

        this.partNumberApiResponse = this._blS
          .GetPartNumberDetail(data.id)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success) {
                this.lst_Stock[i].partNumbers =
                  res.result && res.result.length > 0 ? res.result : [];
              } else {
                this._cS.displayMessage(
                  ResponseMessageStatus.error,
                  res.message
                );
              }
              this.isPartNumberLoaded = false;
            }
          });
      }
    }, 10);
    this.lst_Stock.map(function (x: any) {
      if (x != data) {
        x.expand = false;
      }
    });
  }

  changeAssigned(event: any, i: number, pi: number) {
    this.lst_Stock[i].partNumbers[pi].visibleAssigned = event;
    this.lst_Stock[i].partNumbers[pi].assignmentList =
      this._blS.getUniqueAssignedList(this.lst_Stock[i].partNumbers[pi]);
    this.lst_Stock[i].partNumbers = [...this.lst_Stock[i].partNumbers];
  }

  removePartNumber(part: any, stock: any, i: number, pi: number) {
    if (this.lst_Stock[i].partNumbers[pi].totalAssignedQuantity == 0) {
      if (this.lst_Stock[i].partNumbers.length > 1) {
        var part: any;
        part = encodeURIComponent(part.partNumber);
        this._blS.DeleteStockPart(stock.id, part).subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              this.lst_Stock[i].partNumbers.splice(pi, 1);
              this.lst_Stock[i].partNumbers = [
                ...this.lst_Stock[i].partNumbers,
              ];
              this._cS.displayMessage(
                ResponseMessageStatus.success,
                res.message
              );
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
          }
        });
      } else {
        this._cS.displayMessage(
          ResponseMessageStatus.info,
          'At least one part number should be needed in stock.'
        );
      }
    } else
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'You can not remove the part because this part is assigned to someone.'
      );
  }

  changeLocation(data: any, event: any, i: number) {
    if (event == '3') {
      this.inWareHouseStockId = data.id;
      this.inWareHouseStockIndex = i;
      this.isVisibleAler = true;
    } else {
      this._blS.UpdateStockLocation(data.id, event).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this._cS.displayMessage(ResponseMessageStatus.success, res.message);
            this.lst_Stock[i].status = event;
            this.lst_Stock[i].isShowlocationChange = false;
            this.lst_Stock = [...this.lst_Stock];
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    }
  }

  cancel() {}

  onSearch(event: any) {
    if (event.which != 9 && event.which != 18 && event.which != 27) {
      clearTimeout(this.timer);
      if (this.searchText.trim().length >= 3) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.lst_Stock = [];
          if (this.stockList_Request) this.stockList_Request.unsubscribe();
          this.getStockList();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.page = 1;
          this.lst_Stock = [];
          this.oldSearchText = '';
          if (this.stockList_Request) this.stockList_Request.unsubscribe();
          this.getStockList();
        }
      }
    }
  }

  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Stock = [];
      if (this.stockList_Request) this.stockList_Request.unsubscribe();
      this.getStockList();
    }
  }

  clickChange() {
    var doc = document.getElementsByClassName(
      'cdk-overlay-connected-position-bounding-box'
    );
    if (doc.length > 0) {
      if (doc[0].classList[1] && doc[0].classList[1] == 'display-none') {
        doc[0].classList.remove('display-none');
      } else doc[0].classList.add('display-none');
    }
  }

  showHistoryModal(data: any) {
    this.isAuditVisible = true;
    this.entityDetails = data;
  }

  hideAuditModal(event: any) {
    this.isAuditVisible = !event.hide;
  }

  onScrollDown() {
    if (this.page != this.stockMaxPageSize) {
      this.page += 1;
      this.getStockList();
    }
  }

  moveToAnotherStock(
    event: any,
    i: any,
    pi: any,
    stockId: any,
    partNumber: any
  ) {
    if (this.lst_Stock[i].partNumbers.length > 1) {
      this.lst_Stock[i].partNumbers[pi].isMoveToModalVisible = event;
      if (this.lst_Stock[i].partNumbers[pi].isMoveToModalVisible) {
        this.movedPartDetail = this.lst_Stock[i].partNumbers[pi];
        this.selectedCustomer = '';
        this._blS.GetStockDropdown(this.lst_Stock[i].id).subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              this.lst_AnotherStocks = res.result ? res.result : [];
              this.selectedStock = this.lst_AnotherStocks[0].value;
              this.GetAssignmentDetails(stockId, partNumber, pi, i);
            }
          }
        });
      }
    } else {
      this.lst_Stock[i].partNumbers[pi].isMoveToModalVisible = false;
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'At least one part number should be needed in stock'
      );
    }
  }

  movePartNumber(data: any, part: any) {
    if (this.selectedStock && this.quantityForMove) {
      this._blS
        .TransferPartNumber(
          part.partNumber,
          data.id,
          this.selectedStock,
          this.quantityForMove,
          this.selectedCustomer ? this.selectedCustomer : ''
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              this._cS.displayMessage(
                ResponseMessageStatus.success,
                res.message
              );
              var findFromIndex = this.lst_Stock.findIndex(
                (x: any) => x.id == data.id
              );
              var partIndex = this.lst_Stock[
                findFromIndex
              ].partNumbers.findIndex(
                (x: any) => x.partNumber == part.partNumber
              );
              // res.result.fromStock.expand = true;
              // res.result.toStock.expand = false;
              // if (findToIndex > -1 && partIndex > -1){
              //   var part = this.lst_Stock[findFromIndex].partNumbers[partIndex];
              //   part.orderedQuantity = this.quantityForMove;
              //   this.lst_Stock[findToIndex].partNumbers.push(this.lst_Stock[findFromIndex].partNumbers[partIndex]);
              // }
              if (findFromIndex > -1 && partIndex > -1) {
                this.quantityForMove == part.orderedQuantity
                  ? this.lst_Stock[findFromIndex].partNumbers.splice(
                      partIndex,
                      1
                    )
                  : (this.lst_Stock[findFromIndex].partNumbers[
                      partIndex
                    ].orderedQuantity -= this.quantityForMove);
                this.lst_Stock[findFromIndex].partNumbers[partIndex][
                  'isMoveToModalVisible'
                ] = false;
                this.quantityForMove = null;
              }
              this.lst_Stock[findFromIndex].partNumbers = [
                ...this.lst_Stock[findFromIndex].partNumbers,
              ];
              this.lst_Stock[findFromIndex].partNumbers = [...res.result];
              this.lst_Stock = [...this.lst_Stock];
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
          }
        });
    } else {
      this._cS.displayMessage(
        ResponseMessageStatus.error,
        'Please enter how may part number you want to move.'
      );
    }
  }

  checkQuantity(part: any) {
    if (this.quantityForMove) {
      var assignedCustomer = part.assignmentList.find(
        (x: any) => x.id == this.selectedCustomer
      );
      if (
        this.quantityForMove >
        (this.selectedCustomer
          ? assignedCustomer.assignedQuantity
          : part.orderedQuantity - part.totalAssignedQuantity)
      ) {
        this.quantityForMove = 0;
        this.isQuantityExists = true;
        this._cS.displayMessage(
          ResponseMessageStatus.warning,
          this.selectedCustomer
            ? 'Entered part quantity to move is greater than the assigned quantity'
            : 'Entered part quantity is greater than available part in the stock'
        );
      } else this.isQuantityExists = false;
    }
  }
  checkAssignedQuantity() {
    if (this.isEditPartPopOver) {
      var formValue = this._fS.addPartNumberForm.value;
      if (formValue.partNumber) {
        var stockIndex = this.lst_Stock.findIndex(
          (obj: any) => obj.id == this.currentStockData.id
        );

        var partIndex = this.lst_Stock[stockIndex].partNumbers.findIndex(
          (obj: any) => obj.partNumber == formValue.partNumber
        );
        if (
          formValue.orderQuantiry <
          this.lst_Stock[stockIndex].partNumbers[partIndex]
            .totalAssignedQuantity
        ) {
          //formValue.orderQuantiry = null;
          //this.isQuantityExists = true;
          this._cS.displayMessage(
            ResponseMessageStatus.warning,
            'Entered part quantity is lesser than assigned part quantity in the stock'
          );
        } else this.isQuantityExists = false;
      }
    }
  }
  AlertOk(): void {
    if (this.inWareHouseStockId != '') {
      this._blS
        .UpdateStockLocation(this.inWareHouseStockId, 3)
        .subscribe((res) => {
          if (res) {
            this.isVisibleAler = false;
            if (res.responseStatus == ResponseStatus.Success) {
              this._cS.displayMessage(
                ResponseMessageStatus.success,
                res.message
              );
              this.lst_Stock.splice(this.inWareHouseStockIndex, 1);
              this.lst_Stock = [...this.lst_Stock];
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
          }
        });
    }
  }

  AlertCancel(): void {
    this.inWareHouseStockId = '';
    this.inWareHouseStockIndex = 0;
    this.isVisibleAler = false;
  }

  isAscPart: boolean = true;
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any = null;
  stockAssignmentDetail: any = null;
  sortPart(isAsc: any, data: any) {
    this.isAscPart = isAsc;
    var ar = data.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    data = ar;
  }

  showAssignmentEdit(assignment: any, stock: any) {
    // this._router.navigate(['/bade-loft/assignment'], {
    //   queryParams: { invoiceNumber: invoice },
    // });
    this.isAssignmentVisible = true;
    this.editAssignmentDetail = assignment;
    this.editAssignmentDetail['assigmentDetails'] = true;
    this.stockAssignmentDetail = stock;
  }

  hideAssignModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
      if (event.data) {
        var findIndex = this.lst_Stock.findIndex(
          (x: any) => x.id == this.stockAssignmentDetail.stockId
        );
        this.onExpandChange(findIndex, true, this.lst_Stock[findIndex]);
      }
    }
  }
  //#endregion
  constructor(
    public _http: HttpClient,
    public _cS: CommonService,
    private _blS: BadeLoftService,
    private nzMessageService: NzMessageService,
    private _cdref: ChangeDetectorRef,
    public _fS: FormsService,
    private _router: Router
  ) {
    this.stockLocation = StockLocation;
    _fS.addPartNumberForm_fb();
  }

  ngOnInit(): void {
    this.lst_StockLocation = this._cS.lst_StockLocation;
    var preReservedData: any = null;
    preReservedData = this._cS.getLocalStorageItem('stock_data');
    if (preReservedData) {
      preReservedData = JSON.parse(preReservedData);
      // this.page = preReservedData.page;
      // this.pageSize = preReservedData.pageSize;
      this.searchText = preReservedData.searchText;
      this.sortBy = preReservedData.sortBy;
      this.sortField = preReservedData.sortField;
      this.isShowArchiveStock = preReservedData.isShowArchiveStock
        ? preReservedData.isShowArchiveStock
        : this.isShowArchiveStock;
    }
    this.getStockList();
  }

  ngOnDestroy(): void {
    // var local_data = { page: this.page, pageSize: this.pageSize, searchText: this.searchText, sortBy: this.sortBy, sortField: this.sortField };
    // this._cS.setLocalStorageItem('stock_data', JSON.stringify(local_data));
  }
}
